import { getAuth } from 'firebase/auth';

const FUNCTION_URL = process.env.REACT_APP_OPENAI_URL;

// Modelo por defecto de las lecturas por Chat Completions (contratos: planilla
// de seguridad social, obligaciones del contratista y autollenado).
// gpt-3.5-turbo fue retirado (404) y gpt-4o-mini sale del API el 2027-01-14;
// gpt-6-luna es el reemplazo que OpenAI indica y cuesta menos. Es un modelo de
// razonamiento: `reasoning_effort: 'none'` lo hace comportarse como uno clásico
// y evita que los tokens de razonamiento se cobren como salida. Las lecturas
// son extracción de JSON sobre texto OCR, no necesitan razonar.
export const DEFAULT_MODEL = 'gpt-6-luna';
export const DEFAULT_REASONING_EFFORT = 'none';

export const completionsCreate = async ({
  model = DEFAULT_MODEL,
  max_tokens = 2048,
  reasoning_effort = DEFAULT_REASONING_EFFORT,
  messages
}) => {
  try {
    // Get Firebase Auth token
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error('User not authenticated');
    }
    const token = await user.getIdToken();

    // Call Google Cloud Function
    const response = await fetch(FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        model,
        max_tokens,
        reasoning_effort,
        messages
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.result) {
      throw new Error(data.error || 'Unknown error from OpenAI service');
    }

    return data.response;
  } catch (error) {
    console.error('Error calling OpenAI function:', error);
    throw error;
  }
};
